import Latest_1 from "./1.png";
import Latest_2 from "./2.png";
import Latest_3 from "./3.png";
import Latest_4 from "./4.png";
import Latest_5 from "./5.png";
import Latest_6 from "./6.png";
import Latest_7 from "./7.png";
import Latest_8 from "./8.png";
import Latest_9 from "./9.png";
import Latest_10 from "./10.png";
import Latest_11 from "./11.png";
import Latest_12 from "./12.png";
import Latest_13 from "./13.png";
import Latest_14 from "./14.png";
import Latest_15 from "./15.png";
import Latest_16 from "./16.png";
import Latest_17 from "./17.png";
import Latest_18 from "./18.png";
import Latest_19 from "./19.png";
import Latest_20 from "./20.png";
import Latest_21 from "./21.png";
import Latest_22 from "./22.png";
import Latest_23 from "./23.png";
import Latest_24 from "./24.png";
import Latest_25 from "./25.png";
import Latest_26 from "./26.png";

export const mediaAssets = {
  Latest_1,
  Latest_2,
  Latest_3,
  Latest_4,
  Latest_5,
  Latest_6,
  Latest_7,
  Latest_8,
  Latest_9,
  Latest_10,
  Latest_11,
  Latest_12,
  Latest_13,
  Latest_14,
  Latest_15,
  Latest_16,
  Latest_17,
  Latest_18,
  Latest_19,
  Latest_20,
  Latest_21,
  Latest_22,
  Latest_23,
  Latest_24,
  Latest_25,
  Latest_26,
};
